import jwtAuthAxios from "../auth/jwtAuth";

const deviceAlertServices = {};
const RULE_DETAIL_INCLUDE_QUERY = "include=rule_conditions,rule_recipients,rule_device_actions";

deviceAlertServices.getRules = async (params = "") => {
    const { data } = await jwtAuthAxios.get(`/automations/device_alert_rules${params}`);
    return data;
};

deviceAlertServices.getRule = async (id, params = `?${RULE_DETAIL_INCLUDE_QUERY}`) => {
    const { data } = await jwtAuthAxios.get(`/automations/device_alert_rules/${id}${params}`);
    return data;
};

deviceAlertServices.createRule = async (params = "", body = {}) => {
    const { data } = await jwtAuthAxios.post(`/automations/device_alert_rules${params}`, body);
    return data;
};

deviceAlertServices.updateRule = async (id, params = "", body = {}) => {
    const { data } = await jwtAuthAxios.put(`/automations/device_alert_rules/${id}${params}`, body);
    return data;
};

deviceAlertServices.deleteRule = async (id) => {
    const { data } = await jwtAuthAxios.delete(`/automations/device_alert_rules/${id}`);
    return data;
};

deviceAlertServices.getRuleEditOptions = async (deviceId = null) => {
    const path = deviceId ? `/automations/device_alert_rules/edit_options?device_id=${deviceId}` : `/automations/device_alert_rules/edit_options`;
    const { data } = await jwtAuthAxios.get(path);
    return data;
};

deviceAlertServices.getNotifications = async (params = "") => {
    const { data } = await jwtAuthAxios.get(`/automations/device_alert_notifications${params}`);
    return data;
};

deviceAlertServices.getNotificationFilterOptions = async () => {
    const { data } = await jwtAuthAxios.get("/automations/device_alert_notifications/filter_options");
    return data;
};

deviceAlertServices.getNotification = async (id, params = "") => {
    const { data } = await jwtAuthAxios.get(`/automations/device_alert_notifications/${id}${params}`);
    return data;
};

deviceAlertServices.resendNotification = async (id) => {
    const { data } = await jwtAuthAxios.post(`/automations/device_alert_notifications/${id}/resend`);
    return data;
};

deviceAlertServices.getTestOptions = async () => {
    const { data } = await jwtAuthAxios.get("/automations/device_alert_notifications/test_options");
    return data;
};

deviceAlertServices.getQueueHealth = async (params = "") => {
    const { data } = await jwtAuthAxios.get(`/automations/device_alert_notifications/queue_health${params}`);
    return data;
};

deviceAlertServices.sendTestNotification = async (body = {}) => {
    const { data } = await jwtAuthAxios.post("/automations/device_alert_notifications/send_test", body);
    return data;
};

export default deviceAlertServices;
